import IContato from '../interfaces/IContato';
import { apiDaInscricao } from './axios';

export const editarInformacoesDeContato = async (idDaInscricao: Number, contato: IContato) => {
  await apiDaInscricao().put(`/informacoesDeContato/${idDaInscricao}`, contato);
};